import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ActivityTypeIcon from 'bundles/apex/activities/type/icon';
import { activityTypes } from 'bundles/apex/activities/type/config';

export default function ActivityTypeOption({ activityType, selected, onClick }) {
  const config = activityTypes[activityType];

  return (
    <div
      className={classNames('apex-activity-type-option', 'one-line', config.key, { selected })}
      onClick={onClick}
    >
      <ActivityTypeIcon activityType={activityType} className="mr-2" />
      {config.label}
      <div className="highlight" />
    </div>
  );
}

ActivityTypeOption.propTypes = {
  activityType: PropTypes.oneOf(Object.keys(activityTypes)).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};
